import { render, staticRenderFns } from "./paisaBaseIntro.vue?vue&type=template&id=191e2a77&scoped=true"
import script from "./paisaBaseIntro.vue?vue&type=script&lang=js"
export * from "./paisaBaseIntro.vue?vue&type=script&lang=js"
import style0 from "./paisaBaseIntro.vue?vue&type=style&index=0&id=191e2a77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191e2a77",
  null
  
)

export default component.exports